(function ($, angular, Cookies, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfJoinDebugger', ['ngDialog', function (ngDialog) {
        
        var link = function (scope, elem) {

            var apiClass = '';
            if (scope.apiSettings.apiInUse == 'development') {
                apiClass = 'development-api';
            }
            else if (scope.apiSettings.apiInUse == 'production') {
                apiClass = 'production-api';
            }
            else if (scope.apiSettings.apiInUse == 'development-test' || scope.apiSettings.apiInUse == 'production-test') {
                apiClass = 'test-api';
            }
            

            scope.debugOptions = {
                show: false,
                tab: {
                    model: false,
                    validationRules: false,
                    validation: false,
                    modelSave: false,
                    validationSave: false,
                    manualData: false,
                    applicationData: false,
                    defaultModel: false,
                    quotePanel: false,
                    formState: false,
                    apiSettings: false
                },
                data: '',
                apiClass: apiClass
            };

            scope.showModels = function ($event) {
                $event.preventDefault();

                var hasSelectedTab = false;
                for (var key in scope.debugOptions.tab) {
                    if (scope.debugOptions.tab.hasOwnProperty(key) && scope.debugOptions.tab[key] === true) {
                        hasSelectedTab = true;
                    }
                }

                if (!hasSelectedTab) {
                    scope.debugOptions.tab['model'] = true;
                }

                ngDialog.open({
                    template: 'modal-debug-models',
                    className: 'ngdialog-theme-plain debugModal',
                    controller: ['$scope', function ($scope) {
                        $scope.onClose = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };
                    }],
                    scope: scope
                });
            };

            scope.showTab = function ($event, debugPanel) {
                $event.preventDefault();
                if (typeof scope.debugOptions.tab[debugPanel] !== 'undefined') {
                    // Close all other tabs.
                    for (var k in scope.debugOptions.tab) {
                        if (scope.debugOptions.tab.hasOwnProperty(k)) {
                            scope.debugOptions.tab[k] = false;
                        }
                    }
                    scope.debugOptions.tab[debugPanel] = true;
                }
            };

            scope.saveCookie = function( $event ) {
                $event.preventDefault();
                Cookies.set('thfJoinForm', scope.model, 1);
                alert('Cookie Saved');
            };

            scope.clearCookie = function( $event ) {
                $event.preventDefault();
                Cookies.set('thfJoinForm', {}, { expires: -1 });
                alert('Cookie Cleared');
            };

            scope.clearLQTCookie = function() {
                Cookies.set('thf-live-quote-tool', {}, { expires: -1 });
                alert('LQT Cookie Cleared');
            };

            scope.manualDataModal = function() {
                ngDialog.open({
                    template: 'modal-debug-manual-data',
                    className: 'ngdialog-theme-plain debugModal debugManualData',
                    controller: ['$scope', function ($scope) {
                        $scope.onClose = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };

                        $scope.onSubmit = function($event) {
                            if (scope.debugOptions.data !== '') {
                                scope.model = scope.modelMigration(JSON.parse(scope.debugOptions.data));
                                $scope.closeThisDialog();
                        }
                        }
                    }],
                    scope: scope
                });
            }
        };

        return {
            'restrict': 'E',
            'replace': true,
            'link': link,
            'templateUrl': function (elem, attr) {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/partials/join-debugger.html');
            }
        };
    }]);
})(jQuery, angular, Cookies, window);